import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const AnnouncedChristmas: FC<SvgIconProps> = ({ viewBox = '0 0 254 170', ...props }) => (
  <SvgIcon viewBox={viewBox} {...props} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      opacity=".5"
      d="m82.6 156.5 26.9-5.7-45.8-24.1-26.9 5.7 45.8 24.1Z"
      fill="url(#announced_christmas_paint0_linear)"
    />
    <path d="m109.5 74.3 80.3-15.1L144 35.1 63.7 50.5l45.8 23.8Z" fill="#FDDE84" />
    <path d="M109.5 74.3v76.4l-45.8-24.1V50.5l45.8 23.8Z" fill="#C39000" />
    <path d="M109.5 74.3v76.4l80.3-15.3V59.2l-80.3 15.1Z" fill="#FCCE09" />
    <path d="m87.9 139.4-6.9-3.6-.4-76.5 7.4 3.9-.1 76.2Z" fill="#980000" />
    <path d="m162.5 44.8-82 14.4 7.4 3.9 81.8-14.5-7.2-3.8Z" fill="#D2002E" />
    <path d="m148.8 143.3 8.4-1.6.5-76.5-8.9 1.6v76.5Z" fill="#AF0527" />
    <path d="m111.5 41.3 46.2 24-8.9 1.6-45.4-24 8.1-1.6Z" fill="#D2002E" />
    <path
      d="M123.3 52.1S106.6 51 102 50.8c-4.6-.3-6.5 2.2-6.5 4.8 0 2.4 2.2 4.3 4.3 5.4 2.2 1.3 11.6 7.5 11.6 7.5l18.3-12.1-6.4-4.3Z"
      fill="#D2002E"
    />
    <path
      d="M129.8 56.1s-8.4 1.6-12.7 2.7c-4.3.8-8.4 1.9-7.5 6.7.8 4.8 6.2 3 9.2.8 2.4-2.6 11-10.2 11-10.2Z"
      fill="#AF0527"
    />
    <path
      d="M125.5 51.8s4.8-12.7 5.9-15.6c1.1-3 3.2-6.2 6.2-4.8 3 1.3 16.2 8.4 16.2 8.4l-22.4 15.9-5.9-3.9Z"
      fill="#D2002E"
    />
    <path
      d="M131.1 55.6s12.7-11.9 14.5-13.5c1.9-1.6 8.1-5.1 8.4-1.1.3 4-3 5.4-6.7 7.5-3.8 2-16.2 7.1-16.2 7.1ZM104.2 52.1l19.7.8 2.2 2.7-13.7 3 10-3.2-6.5-.3L121 54l-16.8-1.9ZM127.6 51l5.4-12.7-3.5 11.3 2.4-3-1.1 3.2s3.8-4.8 3.8-4.6l-2.7 5.4 10.5-8.6-11.6 10.8-3.2-1.8Z"
      fill="#AF0527"
    />
    <path
      d="M131.4 51.5c2.2 1.1 2.2 3.2 0 4.3-2.2 1.1-5.4 1.1-7.5 0-2.2-1.1-2.2-3.2 0-4.3 2.1-1.3 5.6-1.3 7.5 0Z"
      fill="#D2002E"
    />
    <path
      d="M131.9 55c-2.2 1.1-5.4 1.1-7.5 0-1.3-.8-1.9-1.9-1.3-3-1.1 1.1-.8 2.7.8 3.8 2.2 1.1 5.4 1.1 7.5 0 .8-.3 1.1-.8 1.3-1.3.1.3-.2.3-.8.5Z"
      fill="#AF0527"
    />
    <defs>
      <linearGradient
        id="announced_christmas_paint0_linear"
        x1="69.823"
        y1="148.297"
        x2="77.835"
        y2="132.192"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
